export const StorageEnum = {
  AUTH_TOKEN: 'auth_token',
};
